
import Dropzone from "dropzone";
import Cropper from 'cropperjs'; 
import 'cropperjs/dist/cropper.css';

export default {
  name: 'RotateImage',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "What is a rotation example?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "There are many practical examples of rotational motion. For instance, the earth rotates on its axis and moves around the sun in an elliptical curvilinear orbit. The other example is a group of people following one another clockwise or counterclockwise."
          }
      },{
          "@type": "Question",
          "name": "What is rotation in a simple way?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Rotation, in a simple way, is a rotation that describes the circular motion of an object around its center. It is moving around an imaginary center or axis."
          }
      },{
          "@type": "Question",
          "name": "What is the general rule for a 360 rotation?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Rotating a point with coordinates (𝑥, 𝑦) under a 360-degree angle will not change its coordinates. The coordinate transformation can represent this rotation: (𝑥, 𝑦) → (𝑥, 𝑦). All 360-degree multiple rotations are equivalent and keep the point coordinates."
          }
      },{
          "@type": "Question",
          "name": "How do you rotate a square?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Rotating a square is not as easy as you imagine. Don't worry, and I will guide you through the following steps: First, shift the origin on the (0, 0) coordinate system to a position that coincides with one side of the square. Perform mesh rotation under an angle of 45° (i.e., part 4 radians). Finally, draw a courtyard at the origin."
          }
      },{
          "@type": "Question",
          "name": "What is a rotating pattern?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "The rotating pattern is where the motif has finished rotating on its axis. In other words, textures can be turned and repeated at any angle. To create uniform designs while maintaining sharpness, most designers usually choose the 90 or 180-degree rotation type."
          }
      }]
    };
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        progress: 0,
        loading: false,
        isActive: false,
        form: this.$vform({ })
    };
  },
  mounted() {

        Dropzone.autoDiscover = false;

        let vm = this;

        var uploadedImageType = 'image/jpeg', uploadedImageName = 'image.jpg';

        var errors = false;

        var myDropzone = new Dropzone(".dropzone", { 
           maxFilesize: 5,
           autoProcessQueue: false,
           maxFiles:1,
           acceptedFiles: "image/*",
           previewsContainer: false,
           thumbnailWidth: null,
           thumbnailHeight: null,
           addedfile: function (file) {
                errors = false;
                if (this.files.length > 1) {
                  this.removeFile(this.files[0]);
                }
           },
           error: function (file, message) {
                this.removeFile(file);
                alert(message);
                errors = true;
           },
           thumbnail: function(file, dataUrl) {

                if(errors) return;
                if (/^image\/\w+/.test(file.type)) {
                    uploadedImageName = file.name;
                    uploadedImageType = file.type;                  
                }

                // start file reader
                let result = document.querySelector('#preview-image'), cropper = '';
                const reader = new FileReader();
                reader.onload = (e)=> {
                    // create new image
                    let img          = document.createElement('img');
                    img.id           = 'image';
                    img.className    = 'img-fluid';
                    img.src          = dataUrl;
                    result.innerHTML = '';
                    result.appendChild(img);
                    initCropper( uploadedImageName, uploadedImageType );

                };
                reader.readAsDataURL(file);
           }
        });

        initCropper( uploadedImageName, uploadedImageType );

        function initCropper( fileName, fileType ){

            // init cropper
            var cropper = window.Cropper;
            var URL     = window.URL || window.webkitURL;
            var image   = document.querySelector('#image');

            var options = {
                dragMode: 'none',
                aspectRatio: 16 / 9,
                autoCrop: false,
                zoomable: false,
                background: false,
                toggleDragModeOnDblclick: false,
                viewMode: 1
            };

            cropper = new Cropper(image, options);

            // Methods
            document.querySelector('.rotate_image').onclick = function(event) {
                var e      = event || window.event;
                var target = e.target || e.srcElement;
                var cropped;
                var result;
                var data;

                while (target !== this) {
                  if (target.getAttribute('data-method')) {
                    break;
                  }

                  target = target.parentNode;
                }

                data = {
                  method: target.getAttribute('data-method'),
                  option: target.getAttribute('data-option') || undefined
                };

                cropped = cropper.cropped;

                if (data.method) {

                  result = cropper[data.method](data.option);

                  switch (data.method) {

                    case 'getCroppedCanvas':

                        if (result) {

                            result.toBlob(function(blob) {

                                vm.onRotateImage(URL.createObjectURL(blob), fileName);

                            }, fileType)
                            
                        }

                      break;

                  }

                }
            };
        }
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onRotateImage(blobURL, fileName) {

        jQuery('.download-image').attr( 'href',  blobURL);

        jQuery('.preview-download-image').attr('src', blobURL);

        jQuery('.download-image').attr('data-filename', fileName);

        jQuery('#modalPreviewDownloadImage').modal('show');
    },
    onDownloadImage( image ) {
        const link   = document.createElement('a');
        var filename = image.srcElement.dataset.filename;
        link.href    = image.srcElement.href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }
    //
  }
}
